import { RightsEvaluationOverridesType } from "./Definitions";

/**
 * Rozhraní pro ověření, jestli komponenta má overrides pro práva.
 * @internal
 */
export interface IHasRightsEvaluationOverrides {
    /** Overrides pro práva */
    rightsEvaluationOverrides: RightsEvaluationOverridesType;
}

export class IHasRightsEvaluationOverrides {
    private static _properties: (keyof IHasRightsEvaluationOverrides)[] = ["rightsEvaluationOverrides"];

    public static [Symbol.hasInstance](instance: any): boolean {
        return instance != null && !this._properties.some((value) => !Reflect.has(instance, value));
    }
}
